import { motion } from 'framer-motion';
import SEO from '../components/SEO';
import { FaInfoCircle, FaHeart, FaGithub, FaEnvelope, FaUserAlt, FaLaptop, FaLink } from 'react-icons/fa';

const About = () => {
  return (
    <div className="max-w-3xl mx-auto px-4 py-10">
      <SEO 
        title="关于我们"
        description="装个机网站介绍，致力于为普通用户提供简单明了的系统重装指南，让每个人都能轻松完成系统安装。"
        keywords="装个机,关于我们,站长介绍,联系我们,技术支持"
      />
      <motion.div
        initial={{ opacity: 0, y: -20 }}
        animate={{ opacity: 1, y: 0 }}
        transition={{ duration: 0.5 }}
        className="text-center mb-8"
      >
        <FaInfoCircle className="text-primary text-4xl mx-auto mb-4" />
        <h1 className="text-3xl font-bold text-gray-800">关于我们</h1>
        <div className="w-20 h-1 bg-primary mx-auto mt-4 rounded-full"></div>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.3, duration: 0.5 }}
        className="bg-white rounded-xl shadow-sm p-6 mb-8 border border-blue-100"
      >
        <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <FaUserAlt className="text-primary mr-2" /> 站长的话
        </h2>
        <p className="text-gray-600 mb-4 leading-relaxed">
          大家好，我是"装个机"网站的站长，同时也是ababtools的创建者。
        </p>
        <p className="text-gray-600 mb-4 leading-relaxed">
          建这个网站的初衷很简单。我发现身边很多大学生、上班族朋友遇到电脑系统问题时，都不太清楚该怎么解决，常常需要花钱找别人帮忙或者在网上搜索大量零散且良莠不齐的教程。
        </p>
        <p className="text-gray-600 leading-relaxed">
          作为一个经常和电脑打交道的人，我觉得重装系统其实没那么复杂，只是很多人缺少清晰明了的指导。所以我打算通过这个网站，用简单易懂的方式分享这些知识，帮助大家学会自己动手解决问题。
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.6, duration: 0.5 }}
        className="bg-white rounded-xl shadow-sm p-6 mb-8 border border-blue-100"
      >
        <h2 className="text-xl font-semibold text-gray-800 mb-4 flex items-center">
          <FaLaptop className="text-blue-500 mr-2" /> 网站初衷
        </h2>
        <p className="text-gray-600 mb-4 leading-relaxed">
          "装个机"-不求人，自己装。网站内容也是如此，没有复杂的技术术语，没有晦涩难懂的说明，全是实用方法。
        </p>
        <p className="text-gray-600 leading-relaxed">
          我希望通过这个网站，让每个人都能轻松掌握电脑系统安装和维护的基本技能。遇到问题，不用求人，自己就能搞定。这样不仅省钱省力，还能增加对自己电脑的了解和掌控感。
        </p>
      </motion.div>

      <motion.div
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ delay: 0.9, duration: 0.5 }}
        className="flex flex-col sm:flex-row justify-center items-center space-y-4 sm:space-y-0 sm:space-x-6 text-center"
      >
        <a
          href="https://ababtools.com"
          target="_blank"
          rel="noopener noreferrer"
          className="flex items-center justify-center bg-gray-800 text-white px-6 py-3 rounded-lg hover:bg-gray-700 transition-colors w-full sm:w-auto"
        >
          <FaLink className="mr-2" /> ababtools
        </a>
        <a
          href="mailto:support@ababtools.com"
          className="flex items-center justify-center bg-primary text-white px-6 py-3 rounded-lg hover:bg-blue-600 transition-colors w-full sm:w-auto"
        >
          <FaEnvelope className="mr-2" /> 联系我们
        </a>
      </motion.div>
    </div>
  );
};

export default About; 